import React, { useEffect, useState } from "react";
import Header from "../components/Delegations/Header";
import Subheader from "../components/Delegations/Subheader";
import BoxButton from "../components/Delegations/BoxButton";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import ModalConfirm from "../components/Generics/ModalConfirm";
import PopupError from "../components/Generics/PopupError";
import { CircularProgress, Grid, Modal } from "@mui/material";
import { getMissingFieldsStep0 } from "../utils/Validation";
import ModalInfo from "../components/Generics/ModalInfo";
import ModalError from "../components/Generics/ModalError";
import PopupSuccess from "../components/Generics/PopupSuccess";
import Step_0_Delegation from "../components/Delegations/ComponentsDelegation/Step_0_Delegation";
import Step_1_Delegation from "../components/Delegations/ComponentsDelegation/Step_1_Delegation";
import Step_2_Delegation from "../components/Delegations/ComponentsDelegation/Step_2_Delegation";
import Step_3_Delegation from "../components/Delegations/ComponentsDelegation/Step_3_Delegation";

import Step_4_Delegation from "../components/Delegations/ComponentsDelegation/Step_4_Delegation";
import Step_5_Delegation from "../components/Delegations/ComponentsDelegation/Step_5_Delegation";
import Step_6_Delegation from "../components/Delegations/ComponentsDelegation/Step_6_Delegation";
import Step_7_Delegation from "../components/Delegations/ComponentsDelegation/Step_7_Delegation";
import Step_8_Delegation from "../components/Delegations/ComponentsDelegation/Step_8_Delegation";

import delegationApi from "../api/DelegationApi";
import Accept_Privacy from "../components/Delegations/ComponentsDelegation/Accept_Privacy";
import ModalConfirmEmail from "../components/Generics/ModalConfirmEmail";

const Delegation = () => {
  const { slug, uid } = useParams();
  const navigate = useNavigate();

  // confirm email delegation created
  const [showConfirmEmailModal, setShowConfirmEmailModal] = useState(false);

  // state
  const [loading, setLoading] = useState(false);
  const [modalOpenError, setModalOpenError] = useState(false);
  const [solicitation, setSolicitation] = useState(null);
  const [delegation, setDelegation] = useState(
    uid
      ? null
      : { personType: "", email: "", signatureMethod: "", telephone: "" },
  );

  const [delegation_already_created, set_delegation_already_created] =
    useState(null);

  const [internalStep, setInternalStep] = useState(null);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [formDataYousign, setFormDataYousign] = useState({
    name: null,
    lastname: null,
    email: null,
    mobile: null,
  });
  const [activeProcessYousign, setActiveProcessYousign] = useState(false);
  // preview documento delegation
  const [previewDocumentDelegation, setPreviewDocumentDelegation] =
    useState(null);
  // true quando la sollecitazione non è valida o scaduta
  const [validSolicitation, setValidSolicitation] = useState(null);
  const [validDelegation, setValidDelegation] = useState(null);
  const [revokedDelegation, setRevokedDelegation] = useState(null);

  const [errors, setErrors] = useState([]);
  const [errorPopup, setErrorPopup] = useState(false);
  const [emailError, setEmailError] = useState(false);
  // documenti
  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [visuraFile, setVisuraFile] = useState(null);
  const [signedDocument, setSignedDocument] = useState(null);

  // STEP4 sistema modale step 3 controlla e conferma che i dati sono OK
  const [openModalConfirmDelegation, setOpenModalConfirmDelegation] =
    useState(false);

  // conferma numero di telefono step form yousign
  const [phoneMatchError, setPhoneMatchError] = useState(false);
  const [confirmNumberPhone, setConfirmNumberPhone] = useState("");
  // const [openModalConfirmDataYousign, setOpenModalConfirmDataYousign] =
  //   useState(false);
  // Conferma email e telefono (usati solo per validazione STEP0)
  const [confirmEmail, setConfirmEmail] = useState("");
  const [confirmTelephone, setConfirmTelephone] = useState("");

  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);

  useEffect(() => {
    if (internalStep === "STEP0" && !uid) {
      setOpenPrivacyModal(true);
    }
  }, [internalStep, uid]);

  const normalize = (num = "") =>
    ("+" + num.replace(/\s+/g, "").replace(/[^\d]/g, "")).replace(/\+\+/, "+");

  const getSolicitation = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}solicitation/${slug}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );

      const fetchedSolicitation = response.data.data;
      setSolicitation(fetchedSolicitation);
      if (fetchedSolicitation) {
        const deactivationDate = fetchedSolicitation.procedureDeactivationDate;
        const now = new Date();

        if (deactivationDate && new Date(deactivationDate) <= now) {
          setValidSolicitation(false);
        } else {
          setValidSolicitation(true);
        }
      } else {
        setValidSolicitation(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setValidSolicitation(false);
      }
      console.error("Errore", error);
    }
  };

  const getDelegation = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}solicitation/${slug}/delegation/${uid}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const fetchedDelegation = response.data.data;

      if (fetchedDelegation) {
        setDelegation(fetchedDelegation);

        if (fetchedDelegation.step) {
          setInternalStep(fetchedDelegation.step);
        }
      } else {
        setDelegation({
          personType: "",
          email: "",
          signatureMethod: "",
          telephone: "",
        });
        setInternalStep("STEP0");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setValidDelegation(true);
      } else {
        setValidDelegation(true);
      }
    }
  };

  useEffect(() => {
    if (!slug) return;

    getSolicitation();
  }, [slug]);

  useEffect(() => {
    const fetchData = async () => {
      if (!uid) {
        // NUOVA DELEGA
        setDelegation({
          personType: "",
          email: "",
          signatureMethod: "",
          telephone: "",
        });
        setInternalStep("STEP0");
      } else {
        await getDelegation();
      }

      await getSolicitation();
    };

    fetchData();
  }, [uid]);

  useEffect(() => {
    if (!delegation) return;

    const storedData = localStorage.getItem("emailValidatedData");
    const parsedData = storedData ? JSON.parse(storedData) : null;

    if (parsedData?.validated && parsedData?.uid === uid) {
      setShowConfirmEmailModal(false);
    } else {
      if (uid) setShowConfirmEmailModal(true);
    }
  }, [delegation, uid]);

  useEffect(() => {
    if (delegation?.status === "REVOKED") {
      setRevokedDelegation(true);
    }
  }, [delegation]);

  useEffect(() => {
    if (delegation?.docBuilderSubmissionData) {
      try {
        const parsedData =
          typeof delegation.docBuilderSubmissionData === "string"
            ? JSON.parse(delegation.docBuilderSubmissionData)
            : delegation.docBuilderSubmissionData;

        setFormDataYousign({
          email: delegation.email,
          mobile: delegation.telephone,
          lastname: parsedData.form_step_1_surname,
          name: parsedData.form_step_1_name,
        });
      } catch (error) {
        console.error("Errore", error);
      }
    }
  }, [delegation]);

  const steps =
    solicitation?.signatureMethods?.length === 1 &&
    solicitation?.signatureMethods[0] === "AUTOGRAPH"
      ? ["STEP0", "STEP1", "STEP2", "STEP3", "STEP5", "STEP8"]
      : solicitation?.signatureMethods?.length === 1 &&
          solicitation?.signatureMethods[0] === "DIGITAL"
        ? ["STEP0", "STEP1", "STEP2", "STEP3", "STEP6", "STEP7", "STEP8"]
        : [
            "STEP0",
            "STEP1",
            "STEP2",
            "STEP3",
            "STEP4",
            "STEP5",
            "STEP6",
            "STEP7",
            "STEP8",
          ];

  const createDelegation = async () => {
    setLoading(true);

    try {
      const response = await delegationApi.createDelegation(slug, delegation);

      const respStatus =
        response?.data?.status ||
        response?.status ||
        response?.data?.data?.status;

      if (respStatus === "DELEGATION_ALREADY_CREATED") {
        set_delegation_already_created(true);
        setLoading(false);
        return true;
      }

      const uid =
        response?.data?.data?.uid || response?.data?.uid || response?.uid;

      localStorage.setItem(
        "emailValidatedData",
        JSON.stringify({
          validated: true,
          uid: uid,
        }),
      );

      navigate(`/solicitation/${slug}/delegation/${uid}`);
      return false;
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
      return false;
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  // STEP 1 - FORM BUILDER
  const setDocBuilder = async (uuid) => {
    setLoading(true);
    try {
      await delegationApi.setDocBuilder(slug, uid, uuid);
      await getDelegation();
      setInternalStep("STEP2");
    } catch (error) {
      setModalOpenError(true);
      console.error("Errore", error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  // ANTEPRIMA DELEGA
  useEffect(() => {
    if (internalStep === "STEP2" && delegation?.docBuilderSubmissionFile) {
      const fetchPreview = async () => {
        try {
          const pathParts = delegation.docBuilderSubmissionFile.split(/[/\\]/);
          const documentPath = pathParts[pathParts.length - 1];

          const response = await axios.get(
            `${process.env.REACT_APP_API_ENDPOINT}solicitation/${slug}/delegation/${uid}/media/${documentPath}`,
            {
              responseType: "blob",
              headers: {
                Accept: "application/pdf",
              },
            },
          );

          const pdfBlob = response.data;
          const pdfUrl = URL.createObjectURL(pdfBlob);

          setPreviewDocumentDelegation(pdfUrl);
        } catch (error) {
          console.error("Errore", error);
          setModalOpenError(true);
        }
      };

      fetchPreview();
    }
  }, [internalStep]);

  // STEP 2 - CONFIRM DATA (VALIDATE)
  const validateSubmission = async () => {
    setLoading(true);
    try {
      await delegationApi.validateSubmission(slug, uid);
      setOpenModalConfirmDelegation(false);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setOpenModalConfirmDelegation(false);
      setModalOpenError(true);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  // STEP 3 - UPLOAD DOCUMENT IDENTITY
  const uploadIdentityDocumentFront = async (documents) => {
    try {
      await delegationApi.uploadIdentityDocumentFront(slug, uid, documents);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const uploadIdentityDocumentBack = async (documents) => {
    try {
      await delegationApi.uploadIdentityDocumentRear(slug, uid, documents);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const uploadIdentityDocumentVisura = async (documents) => {
    try {
      await delegationApi.uploadIdentityDocumentUnique(slug, uid, documents);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const confirmIdentityDocument = async (typeDocument) => {
    try {
      await delegationApi.confirmIdentityDocument(slug, uid, typeDocument);
      setOpenModalConfirmDelegation(false);
      if (solicitation?.signatureMethods?.length === 1) {
        const onlyMethod = solicitation.signatureMethods[0];
        await setSignatureMethod(onlyMethod);
      } else {
        await getDelegation();
      }
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const deleteDocument = async (documentType) => {
    try {
      await delegationApi.deleteDocument(slug, uid, documentType);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const setDocumentType = async (typeDocument) => {
    try {
      await delegationApi.setDocumentType(slug, uid, typeDocument);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  // GET MEDIA (DOWNLOAD / PREVIEW)
  const getMedia = async (documentString, customName) => {
    setLoading(true);
    try {
      const response = await delegationApi.getMedia(slug, uid, documentString);
      const pdfBlob = response.data;
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const documentPath = customName
        ? customName
        : documentString.split(/[/\\]/).pop();

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = documentPath;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // solo anteprima:
      setPreviewDocumentDelegation(pdfUrl);
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    } finally {
      setLoading(false);
    }
  };

  // STEP 4 - SIGNATURE METHOD
  const setSignatureMethod = async (signatureMethod) => {
    try {
      await delegationApi.setSignatureMethod(slug, uid, signatureMethod);

      if (signatureMethod === "DIGITAL") {
        await startSignatureProcess();

        setInternalStep("STEP7");
        return;
      }

      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const confirmSignatureMethod = async () => {
    try {
      const isSingleDigital =
        solicitation?.signatureMethods?.length === 1 &&
        solicitation.signatureMethods[0] === "DIGITAL";

      if (isSingleDigital) {
        await confirmIdentityDocument(selectedDocumentType);
        return;
      }

      if (delegation.signatureMethod === "DIGITAL") {
        await setSignatureMethod("DIGITAL");
        return;
      }

      await setSignatureMethod(delegation.signatureMethod);
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const uploadDocumentSigned = async (documents) => {
    try {
      await delegationApi.uploadSignedDocument(slug, uid, documents);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  const confirmSignedDocument = async (signedDocument) => {
    try {
      await delegationApi.confirmSignedDocument(slug, uid, signedDocument);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    }
  };

  // SIGNATURE PROCESS
  const startSignatureProcess = async () => {
    setLoading(true);
    // setOpenModalConfirmDataYousign(false);
    try {
      const response = await delegationApi.startSignatureProcess(
        slug,
        uid,
        formDataYousign,
      );

      if (response.data.data.digitalSignLink) {
        setActiveProcessYousign(true);
      }

      await getDelegation();
    } catch (error) {
      console.error("Errore", error);

      if (
        error.response.data.message ===
        "You have some invalid params in your payload."
      ) {
        setModalOpenError(true);
      } else {
        setModalOpenError(true);
      }
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  const endSignatureProcess = async () => {
    setLoading(true);
    try {
      await delegationApi.endSignatureProcess(slug, uid);
      await getDelegation();
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  // DOWNLOAD DELEGA
  const downloadDelegation = async () => {
    setLoading(true);
    try {
      if (!delegation?.docBuilderSubmissionFile) return;

      const response = await delegationApi.downloadDelegation(
        slug,
        uid,
        delegation.docBuilderSubmissionFile,
      );

      const pdfBlob = response.data;
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = "delega";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Errore", error);
      setModalOpenError(true);
    } finally {
      setLoading(false);
    }
  };

  // validation formato email
  const handleEmailFormat = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalid = email.trim() !== "" && !emailRegex.test(email);
    setEmailError(invalid);
    return !invalid;
  };

  const goToStep4WithValidation = async () => {
    const newErrors = [];

    if (!delegation.identityDocumentType) {
      newErrors.push("identityDocumentType");
    }

    // Validazione documenti
    if (delegation.personType === "NATURAL" && selectedDocumentType === "CI") {
      if (!frontFile && !delegation.identityDocumentFront)
        newErrors.push("identityDocumentFront");
      if (!backFile && !delegation.identityDocumentRear)
        newErrors.push("identityDocumentRear");
    } else if (
      delegation.personType === "NATURAL" &&
      selectedDocumentType === "PASSPORT"
    ) {
      if (!frontFile && !delegation.identityDocumentFront)
        newErrors.push("identityDocumentFront");
    } else if (
      delegation.personType === "JURIDICAL" &&
      selectedDocumentType === "CI"
    ) {
      if (!frontFile && !delegation.identityDocumentFront)
        newErrors.push("identityDocumentFront");
      if (!backFile && !delegation.identityDocumentRear)
        newErrors.push("identityDocumentRear");
      if (!visuraFile && !delegation.identityDocumentUnique)
        newErrors.push("identityDocumentUnique");
    } else if (
      delegation.personType === "JURIDICAL" &&
      selectedDocumentType === "PASSPORT"
    ) {
      if (!frontFile && !delegation.identityDocumentFront)
        newErrors.push("identityDocumentFront");
      if (!visuraFile && !delegation.identityDocumentUnique)
        newErrors.push("identityDocumentUnique");
    }

    if (newErrors.length > 0) {
      setErrors(newErrors);
      setErrorPopup(true);
      return;
    }

    if (
      solicitation?.signatureMethods?.length === 1 &&
      solicitation.signatureMethods[0] === "DIGITAL"
    ) {
      await confirmSignatureMethod();
      return;
    }

    await confirmIdentityDocument(selectedDocumentType);
  };

  const goToStep6WithValidation = () => {
    const newErrors = [];

    // Validazione documento
    if (delegation.signatureMethod === "AUTOGRAPH") {
      if (!delegation.signedDocument) newErrors.push("signedDocument");
    }

    if (newErrors.length > 0) {
      setErrors(newErrors);
      setErrorPopup(true);
      return;
    }

    if (delegation.signatureMethod === "AUTOGRAPH") {
      confirmSignedDocument(signedDocument);
    } else if (delegation.signatureMethod === "DIGITAL") {
      startSignatureProcess();
      // setOpenModalConfirmDataYousign(true);
    }
  };

  const handleNextStep = async () => {
    try {
      if (internalStep === "STEP0") {
        const missing = getMissingFieldsStep0(
          delegation,
          confirmEmail,
          confirmTelephone,
        );
        setErrors(missing);

        if (missing.length > 0 || emailError) {
          setErrorPopup(true);
          return;
        }

        setErrorPopup(false);

        const already = await createDelegation();

        if (already) {
          return;
        }
      }

      // Gestione step
      switch (internalStep) {
        case "STEP1":
          break;
        case "STEP2":
          setOpenModalConfirmDelegation(true);
          return;
        case "STEP3":
          goToStep4WithValidation();
          return;
        case "STEP4":
          if (!delegation.signatureMethod) {
            setErrors(["signatureMethod"]);
            setErrorPopup(true);
            return;
          }

          if (delegation.signatureMethod === "DIGITAL") {
            await confirmSignatureMethod();
            return;
          }
          await setSignatureMethod(delegation.signatureMethod);
          break;

        case "STEP5":
          goToStep6WithValidation();
          return;
        case "STEP6":
          goToStep6WithValidation();
          return;

        default:
          break;
      }

      const filteredSteps = steps.filter((step) => {
        if (step === "STEP5" && delegation.signatureMethod !== "AUTOGRAPH")
          return false;
        if (step === "STEP6" && delegation.signatureMethod !== "DIGITAL")
          return false;
        return true;
      });

      const currentIndex = filteredSteps.indexOf(internalStep);
      const newIndex = currentIndex + 1;
      if (newIndex < filteredSteps.length) {
        setInternalStep(filteredSteps[newIndex]);
      }
    } catch (error) {
      console.error("Errore", internalStep, error);
    }
  };

  const goToStep = (direction) => {
    if (
      internalStep === "STEP5" &&
      solicitation?.signatureMethods?.length === 1 &&
      solicitation.signatureMethods[0] === "DIGITAL" &&
      direction === "prev"
    ) {
      setInternalStep("STEP4");
      return;
    }

    if (
      internalStep === "STEP6" &&
      delegation?.signatureMethod === "DIGITAL" &&
      direction === "prev"
    ) {
      setInternalStep("STEP4");
      return;
    }

    const currentIndex = steps.indexOf(internalStep);
    const newIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;

    if (newIndex >= 0 && newIndex < steps.length) {
      setInternalStep(steps[newIndex]);
    }
  };

  const renderStepComponent = () => {
    switch (internalStep) {
      case "STEP0":
        return (
          <>
            <Step_0_Delegation
              delegation={delegation}
              setDelegation={setDelegation}
              errors={errors}
              handleEmailFormat={handleEmailFormat}
              emailError={emailError}
              confirmEmail={confirmEmail}
              setConfirmEmail={setConfirmEmail}
              confirmTelephone={confirmTelephone}
              setConfirmTelephone={setConfirmTelephone}
              setErrors={setErrors}
            />
          </>
        );

      case "STEP1":
        return (
          <Step_1_Delegation
            setErrorPopup={setErrorPopup}
            goToStep={goToStep}
            handleNextStep={handleNextStep}
            setDocBuilder={setDocBuilder}
            delegation={delegation}
            solicitation={solicitation}
            setInternalStep={setInternalStep}
          />
        );

      case "STEP2":
        return (
          <Step_2_Delegation
            previewDocumentDelegation={previewDocumentDelegation}
            privacyAccepted={privacyAccepted}
            setPrivacyAccepted={setPrivacyAccepted}
          />
        );

      case "STEP3":
        return (
          <Step_3_Delegation
            errors={errors}
            delegation={delegation}
            frontFile={frontFile}
            backFile={backFile}
            visuraFile={visuraFile}
            uploadIdentityDocumentFront={uploadIdentityDocumentFront}
            uploadIdentityDocumentBack={uploadIdentityDocumentBack}
            uploadIdentityDocumentVisura={uploadIdentityDocumentVisura}
            setFrontFile={setFrontFile}
            setBackFile={setBackFile}
            setVisuraFile={setVisuraFile}
            setSelectedDocumentType={setSelectedDocumentType}
            selectedDocumentType={selectedDocumentType}
            deleteDocument={deleteDocument}
            setDocumentType={setDocumentType}
            getMedia={getMedia}
            setErrors={setErrors}
          />
        );

      case "STEP4":
        return (
          <Step_4_Delegation
            errors={errors}
            delegation={delegation}
            setDelegation={setDelegation}
            setErrors={setErrors}
          />
        );

      case "STEP5":
        if (delegation.signatureMethod === "AUTOGRAPH") {
          return (
            <Step_5_Delegation
              delegation={delegation}
              signedDocument={signedDocument}
              setSignedDocument={setSignedDocument}
              downloadDelegation={downloadDelegation}
              uploadDocumentSigned={uploadDocumentSigned}
              errors={errors}
              setErrors={setErrors}
              deleteDocument={deleteDocument}
            />
          );
        }
        return null;

      case "STEP6":
        if (delegation.signatureMethod === "DIGITAL") {
          return (
            <Step_6_Delegation
              delegation={delegation}
              formDataYousign={formDataYousign}
              setFormDataYousign={setFormDataYousign}
              errors={errors}
              activeProcessYousign={activeProcessYousign}
              endSignatureProcess={endSignatureProcess}
              setPhoneMatchError={setPhoneMatchError}
              phoneMatchError={phoneMatchError}
              setConfirmNumberPhone={setConfirmNumberPhone}
              confirmNumberPhone={confirmNumberPhone}
            />
          );
        }
        return null;

      case "STEP7":
        if (delegation.signatureMethod === "DIGITAL") {
          return (
            <Step_7_Delegation
              delegation={delegation}
              formDataYousign={formDataYousign}
              setFormDataYousign={setFormDataYousign}
              errors={errors}
              activeProcessYousign={activeProcessYousign}
              endSignatureProcess={endSignatureProcess}
            />
          );
        }
        return null;

      case "STEP8":
        return <Step_8_Delegation delegation={delegation} />;

      default:
        return null;
    }
  };

  // popup error

  const closePopupError = () => {
    setErrorPopup(false);
  };

  const handleCloseErrorModal = () => {
    setModalOpenError(false);
  };

  useEffect(() => {
    if (errors.length > 0) {
      const timer = setTimeout(() => {
        setErrorPopup(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [errors]);

  const getActiveModal = () => {
    if (revokedDelegation) return "revokedDelegation";
    if (validSolicitation === false) return "validSolicitation";
    return null;
  };

  const activeModal = getActiveModal();
  const showComponents = !activeModal && !showConfirmEmailModal;

  // dowload delega firmata
  function goToAieda() {
    window.location.href = "https://aieda.it/";
  }

  // carica ogni pagina dall'alto
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [internalStep]);

  return (
    <>
      {/* Loading overlay */}
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.33)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999,
          }}
        >
          <CircularProgress style={{ color: "#fff" }} />
        </div>
      )}

      {/* Header e Subheader sempre visibili */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: "9998",
          backgroundColor: "#fff",
        }}
      >
        <Header
          solicitation={solicitation}
          validSolicitation={validSolicitation}
        />
        {!revokedDelegation &&
          activeModal !== "validSolicitation" &&
          !validDelegation &&
          !showConfirmEmailModal && (
            <Subheader delegation={delegation} internalStep={internalStep} />
          )}
      </div>

      {showComponents && (
        <div>
          {" "}
          {delegation && renderStepComponent()}
          {internalStep !== "STEP1" &&
            internalStep !== null &&
            validSolicitation !== false && (
              <BoxButton
                solicitation={solicitation}
                delegation={delegation}
                phoneMatchError={phoneMatchError}
                internalStep={internalStep}
                onNext={handleNextStep}
                onPrevious={() => goToStep("prev")}
                getMedia={getMedia}
                getDelegation={getDelegation}
                privacyAccepted={privacyAccepted}
              />
            )}
        </div>
      )}

      <Modal
        open={modalOpenError}
        onClose={handleCloseErrorModal}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 20000,
          },
        }}
        style={{ zIndex: 20001 }}
      >
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 20002,
          }}
        >
          <ModalError
            onClose={handleCloseErrorModal}
            title="Errore"
            descriptionOne="Si è verificato un errore tecnico momentaneo."
            descriptionTwo="Ti invitiamo a riprovare tra qualche minuto. Grazie."
            copyButton="Chiudi"
            confirm={handleCloseErrorModal}
          />
        </div>
      </Modal>

      {activeModal === "revokedDelegation" && (
        <ModalInfo
          title="Delega revocata"
          descriptionOne="Questa delega è stata revocata e non può più essere utilizzata."
          copyButton="Chiudi"
          confirm={goToAieda}
          disableBackdropClick={true}
        />
      )}

      {/* MODALE VERIFICA E CONFERMA INVIO DELEGA  */}
      {openModalConfirmDelegation && (
        <div>
          <ModalConfirm
            iconOff={true}
            onClose={() => setOpenModalConfirmDelegation(false)}
            title="Avviso"
            descriptionOne={
              <>
                Con la conferma{" "}
                <span style={{ fontWeight: "bold" }}>
                  garantisci la correttezza di tutti i dati
                </span>{" "}
                inseriti e rendi definitivo il contenuto della delega.
              </>
            }
            descriptionTwo="Confermi di voler procedere alla firma?"
            copyButton="Confermo"
            confirm={() => validateSubmission()}
          />
        </div>
      )}

      {/* MODALE AVVISO DELEGA GIA' CREATA  */}
      {delegation_already_created && (
        <div>
          <ModalConfirm
            iconOff={true}
            onClose={() => set_delegation_already_created(false)}
            title="Email già utilizzata"
            descriptionOne="L’email inserita è associata a una delega già esistente. Controlla la casella email in questione e recupera il link per riprendere il processo di delega avviato in precedenza."
            descriptionTwo=""
            copyButton="Chiudi"
            confirm={() => set_delegation_already_created(false)}
          />
        </div>
      )}

      {activeModal === "validSolicitation" && (
        <ModalInfo
          title="Sollecitazione inattiva"
          descriptionOne="Questa sollecitazione di deleghe è scaduta o inattiva."
          descriptionTwo=""
          copyButton="Chiudi"
          confirm={goToAieda}
          disableBackdropClick={true}
        />
      )}

      {validDelegation && (
        <ModalInfo
          title="Delega inattiva"
          descriptionOne="Questa delega non è più disponibile in quanto scaduta o revocata."
          copyButton="Chiudi"
          confirm={goToAieda}
        />
      )}

      {/* Popup errori campi */}
      {errorPopup && showComponents && (
        <div
          style={{
            width: "90%",
            maxWidth: "380px",
            minWidth: "250px",
            position: "fixed",
            bottom: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 10000,
            padding: "12px 10px",
            borderRadius: "0px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
            backgroundColor: "#fff",
          }}
        >
          <PopupError
            copyError="Uno o più campi obbligatori sono mancanti"
            closePopupError={closePopupError}
          />
        </div>
      )}

      {/* modal confirm email - delegation esistente  */}
      {showConfirmEmailModal && (
        <ModalConfirmEmail
          delegation={delegation}
          onClose={() => setShowConfirmEmailModal(false)}
          confirm={() => setShowConfirmEmailModal(false)}
          copyButton="Valida"
          iconOff={true}
        />
      )}
    </>
  );
};

export default Delegation;
